var __defProp = Object.defineProperty;
var __name = (target, value) => __defProp(target, "name", { value, configurable: true });
function isTouchDevice() {
  return typeof window !== "undefined" && !!(window && window.ontouchstart !== void 0 || window.navigator && (window.navigator.msMaxTouchPoints || window.navigator.maxTouchPoints) > 2);
}
__name(isTouchDevice, "isTouchDevice");
export {
  isTouchDevice
};
